import { Component, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { PopupStatus } from '../../constants';

@Component({
  selector: 'com-popup-message',
  templateUrl: './popup-message.component.html',
  styleUrls: ['./popup-message.component.scss'],
})
export class PopupMessageComponent {
  PopupStatus = PopupStatus;
  status: PopupStatus = PopupStatus.Information;

  constructor(
    public snackBarRef: MatSnackBarRef<PopupMessageComponent>,
    @Inject(MAT_SNACK_BAR_DATA) public data: any
  ) {}

  isArray(data: string | string[]) {
    return Array.isArray(data);
  }
}
